import { fmtCLP } from "../../utils/formato";
import "./ProductGrid.css";

export default function ProductGrid({
  filtro, setFiltro,
  categorias,
  busqueda, setBusqueda,
  menuFiltrado,
  cargandoProductos,
  errorProductos,
  envolturaDraft, setEnvolturaDraft,
  enviando,
  isMobileLayout,
  cajaAbierta,
  onAgregarItem,
  onOpenEnvelope,
  onOpenItemLibre,
}) {
  return (
    <div className="col-products pg-card">
      {cajaAbierta === false && (
        <div className="pg-locked">
          <span className="pg-locked__icon">🔒</span>
          <span className="pg-locked__text">Iniciá la caja para agregar productos</span>
        </div>
      )}

      <div className="pg-header">
        {/* Cabecera */}
        <div className="pg-section__head">
          <div className="pg-section__icon">🍱</div>
          <h3 className="pg-section__title">Productos</h3>
        </div>

        {/* Buscador */}
        <div className="pg-search-wrap">
          <span className="pg-search-wrap__icon" aria-hidden>🔍</span>
          <input
            className="pg-search"
            type="text"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="Buscar producto…"
          />
          {busqueda && (
            <button
              type="button"
              className="pg-search-clear"
              onClick={() => setBusqueda("")}
              title="Limpiar búsqueda"
              aria-label="Limpiar búsqueda"
            >
              ×
            </button>
          )}
        </div>

        {/* Pills de categorías */}
        <div className="pg-pills" role="group" aria-label="Categoría">
          {(Array.isArray(categorias) ? categorias : []).map((c) => (
            <button
              key={String(c)}
              type="button"
              className={`pg-pill${filtro === c ? " active" : ""}`}
              onClick={() => setFiltro(c)}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* Contador + estado */}
      {errorProductos ? (
        <div className="pg-error">Error: {String(errorProductos)}</div>
      ) : (
        <div className="pg-count">
          {cargandoProductos
            ? "Cargando productos…"
            : `${menuFiltrado.length} resultado${menuFiltrado.length === 1 ? "" : "s"}`}
        </div>
      )}

      {/* Grilla */}
      <div className="pg-grid">
        {cargandoProductos ? (
          <div className="pg-empty">Cargando…</div>
        ) : (Array.isArray(menuFiltrado) ? menuFiltrado : []).map((item) => {
          if (!item || item.id == null) return null;

          const nombre = item.nombre != null ? String(item.nombre) : "";
          const envolturas = Array.isArray(item.envolturas) ? item.envolturas : [];
          const showWrapSelect = !isMobileLayout && envolturas.length > 0;
          const stock = item.stock ?? 0;
          const controlStock = item.control_stock ?? false;
          const sinStock = controlStock && stock <= 0;
          const conStock = controlStock && stock > 0; // Solo mostrar indicador si control_stock está habilitado

          const onAdd = () => {
            if (isMobileLayout && envolturas.length > 0) {
              onOpenEnvelope(item);
            } else {
              onAgregarItem(item);
            }
          };

          return (
            <article key={item.id} className={`pg-item${sinStock ? " pg-item--agotado" : ""}`}>
              <div className="pg-item__name">{nombre}</div>
              <div className="pg-item__row">
                <span className="pg-item__price">{fmtCLP(item.precio)}</span>
                <button
                  type="button"
                  className="pg-item__add"
                  onClick={onAdd}
                  disabled={enviando || cargandoProductos || sinStock}
                  title={sinStock ? "Sin stock disponible" : "Agregar al pedido"}
                  aria-label={sinStock ? "Sin stock disponible" : "Agregar al pedido"}
                >
                  {sinStock ? "✕" : "+"}
                </button>
              </div>
              {controlStock && (
                <div className={`pg-item__stock ${sinStock ? "agotado" : ""}`}>
                  {sinStock ? "Agotado" : `${stock} disponible`}
                </div>
              )}

              {showWrapSelect && (
                <select
                  className="pg-item__wrap"
                  value={envolturaDraft[item.id] || ""}
                  onChange={(e) =>
                    setEnvolturaDraft((prev) => ({ ...prev, [item.id]: e.target.value }))
                  }
                >
                  <option value="">Envoltura</option>
                  {envolturas.map((ev) => (
                    <option key={ev} value={ev}>{ev}</option>
                  ))}
                </select>
              )}
            </article>
          );
        })}

        {!cargandoProductos && menuFiltrado.length === 0 && (
          <div className="pg-empty">
            {busqueda
              ? `Sin resultados para "${busqueda}"`
              : "No hay productos en esta categoría."}
          </div>
        )}

        {/* Ítem libre — siempre al final de la grilla */}
        {!cargandoProductos && (
          <article
            className="pg-item pg-item--libre"
            role="button"
            tabIndex={cajaAbierta !== false ? 0 : -1}
            onClick={() => cajaAbierta !== false && onOpenItemLibre?.()}
            onKeyDown={(e) => e.key === "Enter" && cajaAbierta !== false && onOpenItemLibre?.()}
          >
            <div className="pg-item__libre-icon">+</div>
            <div className="pg-item__libre-label">Ítem libre</div>
            <div className="pg-item__libre-hint">Precio a definir</div>
          </article>
        )}
      </div>
    </div>
  );
}
